import { Flex, Icon, Text } from '@/ui';
import type { ConsentScope } from './useConsentRequest';

type Props = {
  scopes: ConsentScope[];
};

export const ConsentScopeList = ({ scopes }: Props) => {
  return (
    <Flex
      as="ul"
      direction="column"
      gap="3"
      layerStyle="ahCard"
      listStyleType="none"
      p="4"
      textAlign="left"
    >
      {scopes.map(({ scope, description }) => (
        <Flex align="flex-start" as="li" gap="3" key={scope}>
          <Icon color="brand.500" flexShrink={0} icon="Checkmark" mt="0.5" />
          <Text color="ink.strong" fontSize="ah-row">
            {description}
          </Text>
        </Flex>
      ))}
    </Flex>
  );
};
